import React from 'react';

const SkeletonLoader = () => {
    return (
      <div className="lg:flex lg:flex-wrap lg:justify-center md:flex md:flex-wrap md:justify-center grid grid-cols-2 lg:gap-4 md:gap-4 gap-5 p-4 lg:px-[10%]">
        {Array.from({ length: 12 }).map((_, index) => (
          <div
            key={index}
            className="lg:w-[240px] lg:h-[375px] md:w-[200px] md:h-[375px] w-[170px] h-[350px] bg-gray-100 animate-pulse rounded-md"
          >
            <div className="lg:w-[240px] md:w-[200px] w-[170px] h-[150px] bg-gray-600 animate-pulse rounded-t-md"></div>
            <div className="p-4">
              <div className="w-3/4 h-4 bg-gray-400 animate-pulse mb-2 rounded"></div>
              <div className="w-1/2 h-4 bg-gray-400 animate-pulse rounded mb-2"></div>
              <div className="w-1/2 h-4 bg-gray-300 animate-pulse rounded mb-2"></div>
              <div className="w-1/2 h-4 bg-gray-200 animate-pulse rounded mb-2"></div>
            </div>
          </div>
        ))}
      </div>
    );
};

export default SkeletonLoader;
